import { EmailData } from '../constants/emails.consts'
import { getDomainExtension } from './getDomainExtension'

export const openEmailClient = (emailConstant: (domain: string) => EmailData) => {
    const domain = getDomainExtension()
    const { recipient } = emailConstant(domain)
    const emailLink = `mailto:${recipient}?subject=${''}&body=${''}`
    window.open(emailLink, '_blank')
}
